import { render, staticRenderFns } from "./MainCanvas.vue?vue&type=template&id=8f0a671e&scoped=true&"
import script from "./MainCanvas.vue?vue&type=script&lang=js&"
export * from "./MainCanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0a671e",
  null
  
)

export default component.exports